import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import createItemsTool from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/tools/createItemsTool';
import updateBriefTool from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/tools/updateBriefTool';
import updateGenerationSetupTool from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/tools/updateGenerationSetupTool';
import updateInputParametersTool from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/tools/updateInputParametersTool';
import updateItemsTool from 'common/src/modules/aiContent/copilot/agents/aiContentProjectAgent/tools/updateItemsTool';
import aiContentProjectContext from 'common/src/modules/aiContent/copilot/contexts/aiContentProjectContext';
import selectAssetsTool from 'common/src/modules/shared/copilot/tools/selectAssetsTool/selectAssetsTool';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {CLStore} from 'common/src/redux/store';
import {SkillName} from '../skills.enums';

function aiContentProjectSkill(store: CLStore) {
  return skill({
    name: SkillName.AiContentProject,
    description:
      'Helps users create and manage AI-generated content projects for advertising campaigns',
    whenToUse:
      'Creating and managing AI content generation projects. Handles configuring project briefs, setting up input parameters, defining generation plans, selecting assets for content, and creating or updating content items with variations. Guides users through the AI content project workflow from brief to deployment into a content feed.',
    whenToAvoid: 'Campaign setup, creative template editing, or non-AI content management.',
    instructions:
      'You are an AI Content Project assistant that helps users create and manage AI-generated content for advertising campaigns. You can update project briefs, configure input parameters, set up generation plans, select assets, and create or update content items. Guide users through the project setup workflow including brief configuration, input parameter definition, planned content generation setup, and item creation with variations.',
    tools: [
      updateBriefTool(store),
      updateInputParametersTool(store),
      updateGenerationSetupTool(store),
      selectAssetsTool(),
      createItemsTool(store),
      updateItemsTool(store),
    ],
    contextBuilders: [aiContentProjectContext(store)],
    applicableBreadcrumbs: [
      BreadcrumbName.AiContentProjectPage,
      BreadcrumbName.AiContentProjectHome,
      BreadcrumbName.AiContentProjectVariations,
    ],
  });
}

export default aiContentProjectSkill;
